import { useMediaQuery, useTheme } from '@mui/material';
import { QrCodeVisitWeb } from 'graphql/generated/graphqlTypes';
import React from 'react';
import VisitsCards from './VisitsCards';
import VisitsDataGrid from './VisitsDataGrid';

interface Props {
  visits: QrCodeVisitWeb[];
  isLoading: boolean;
  onCancelVisit?: (visitId: string) => Promise<void>;
  showDetails?: boolean;
}

const VisitsTable: React.FC<Props> = ({ visits, isLoading, onCancelVisit, showDetails }) => {
  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmall = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  if (isExtraSmall) {
    return (
      <VisitsCards
        variant="stacked"
        visits={visits}
        isLoading={isLoading}
        onCancelVisit={onCancelVisit}
        showDetails={showDetails}
      />
    );
  }

  if (isSmall) {
    return (
      <VisitsCards
        variant="inline"
        visits={visits}
        isLoading={isLoading}
        onCancelVisit={onCancelVisit}
        showDetails={showDetails}
      />
    );
  }

  return (
    <VisitsDataGrid visits={visits} isLoading={isLoading} onCancelVisit={onCancelVisit} showDetails={showDetails} />
  );
};

export default VisitsTable;
